import gql from 'graphql-tag';

export default gql`
  fragment userInfo on User {
    id
    profilePhoto
    coverPhoto
    name
    firstName
    description
    website
    username
    isOnline
    timezone
    totalReputation
    betaSupporter
    lastName
    city
    country
    university
    applicationYear
    messageUserId
    role
    profileSign
    pronoun
    specialties
    email
    hasAgreedToTerms
    primaryRole
    canViewAdmin
    canViewCGA
  }
`;
